<template>
  <c-base-dialog v-model="isShow" :option="option" @close="$emit('close')">
    <template slot="body">
      <div :class="['dialog', 'dialog--default', !isMobile ? 'dialog--pc' : '']">
        <div class="dialog-content">
          <div>
            <table class="table">
              <tr>
                <th class="table-title-time">充值时间</th>
                <th class="table-title-num">充值档位</th>
                <th class="table-title-num">实销金额</th>
              </tr>
              <tr v-for="(item, index) of showList" :key="index">
                <td class="reward-list-item">{{ getTime(item) }}</td>
                <td
                  class="reward-list-item"
                  :style="{ paddingLeft: !isMobile ? '10px' : '0.1rem' }"
                >
                  {{ item.TotalPrice / 100 }}元
                </td>
                <td
                  class="reward-list-item"
                  :style="{ paddingLeft: !isMobile ? '10px' : '0.1rem' }"
                >
                  {{ item.RealPay / 100 }}元
                </td>
              </tr>
            </table>
          </div>
        </div>
        <div class="reward-page" v-if="Math.ceil(page.total / pageSize) > 1">
          <a @click="page.current > 1 && page.current--">上一页</a>
          {{ page.current }}/{{ Math.ceil(page.total / pageSize) }}
          <a
              @click="page.current < page.total / pageSize && page.current++"
          >下一页</a>
        </div>
      </div>
    </template>
  </c-base-dialog>
</template>

<script>
import CDialog from '../base-dialog';
import common from '../../common';
import Vue from 'vue';

const SELL_CHANNEL_MAP = {
  tgclub: '1',
  supercore: '4',
};

const DEFAULT_PAY_BUSINESS = 'act';

export default {
  name: 'recharge-record',
  components: {
    [CDialog.name]: CDialog,
  },
  props: {
    thisFlowRequest: Function,
    myRoleInfo: Object,
    payBusiness: String, // 支付流水归属
    sellChannel: String, // 销售渠道
    flowId: String, // 查询条件ID
    option: Object,
    pageSize: Number, // 每页展示数
    spInfo: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      isMobile: /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent),
      list: [],
      showList: [],
      page: {
        current: 1,
        total: 0,
      },
      isShow: true,
    };
  },
  watch: {
    'page.current'() {
      this.freshList();
    },
  },
  methods: {
    getTime(item) {
      return common.tool.toDateTimeString(new Date(item.CreateAt * 1000));
    },

    getConfigFromActInfo(giftId, type) {
      const receiveGiftCustomConfig = Vue.prototype?.$actInfo?.extendConfig?.receiveGiftCustomConfig ?? [];
      console.log('receiveGiftCustomConfig = ', receiveGiftCustomConfig, giftId, type);
      const record = receiveGiftCustomConfig?.
        find(item => parseInt(item.gift_id, 10) === parseInt(giftId, 10) && item.type === type);
      console.log('receiveGiftCustomConfig  record = ', record);
      return record;
    },

    async freshList() {
      this.showList = this.list.slice(
        (this.page.current - 1) * this.pageSize,
        (this.page.current - 1) * this.pageSize + this.pageSize,
      );
      console.log('showList=', this.showList);
    },

    async getRechargeRecordList() {
      console.log('getRechargeRecordList', `ceiba_act_${this.$actInfo.activity_id}`);
      const sellScene = `ceiba_act_${this.$actInfo.activity_id}`;
      const response = await this.thisFlowRequest({
        flowId: this.flowId,
        params: {
          role: this.myRoleInfo,
          sell_channel: this.sellChannel || SELL_CHANNEL_MAP[this.$actInfo.ast],
          data: JSON.stringify({
            role: this.myRoleInfo,
            payInfo: {
              business: this.payBusiness || DEFAULT_PAY_BUSINESS,
              sell_channel: this.sellChannel || SELL_CHANNEL_MAP[this.$actInfo.ast],
              platform: common.platform.isAndroid ? 'android' : 'ios',
              role: this.myRoleInfo,
              path_through: '',
              channel: 'h5', // 先写死h5
              sell_scene: sellScene,
              sp_info: this.spInfo, // midas券信息
            },
          }),
        },
      });
      const { ret, msg, data } = response;
      const { ret: dataRet, data: dataData } = data;
      if (ret !== 0 || dataRet !== 0) {
        this.$alert({ msg: msg || '网络繁忙' });
        return false;
      }
      this.page.total = dataData.length;
      this.list = dataData;
      this.showList = dataData.slice(
        (this.page.current - 1) * this.pageSize,
        (this.page.current - 1) * this.pageSize + this.pageSize,
      );
      this.freshList();
    },
  },
  async mounted() {
    this.getRechargeRecordList();
    // console.log('this.pageSize=', this.pageSize, this.list, this.isMobile);
  },
};
</script>

<style scoped>
.modal {
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.8);
  z-index: 100;
}

.dialog {
  font-size: 0.2rem;
  background-size: 100% 100%;
  display: flex;
  justify-content: center;
  flex-direction: column;
  width: 7.2rem;
  position: absolute;
}

.dialog-content {
  text-align: center;
  margin: 0 auto;
}

.dialog--default .table {
  border-collapse: collapse;
  width: 5.5rem;
  height: 2.3rem;
  margin: 0 auto;
  position: relative;
}

.dialog--default .reward-list-item {
  font-size: 0.24rem;
  white-space: nowrap;
}

.dialog--default .table-title-time {
  font-size: 0.28rem;
  padding-top: 0.1rem;
  line-height: 0.3rem;
  padding-bottom: 0.3rem;
  width: 45%;
}

.dialog--default .table-title-num {
  font-size: 0.28rem;
  padding-top: 0.1rem;
  line-height: 0.3rem;
  padding-bottom: 0.3rem;
  width: 27%;
}

.dialog--default .item-link {
  margin-left: 0.1rem;
  text-decoration: underline;
}

.dialog--default .reward-page {
  margin-top: 0.28rem;
}

/* pc */

.dialog--pc {
  font-size: 20px;
  width: 720px;
}

.dialog--pc .table {
  width: 550px;
  height: 230px;
}

.dialog--pc .reward-list-item {
  font-size: 24px;
}

.dialog--pc .table-title-time {
  font-size: 28px;
  padding-top: 10px;
  line-height: 30px;
  padding-bottom: 30px;
  width: 45%;
}

.dialog--pc .table-title-num {
  font-size: 28px;
  padding-top: 10px;
  line-height: 30px;
  padding-bottom: 30px;
  width: 27%;
}

.dialog--pc .item-link {
  margin-left: 10px;
}

.dialog--pc .reward-page {
  margin-top: 28px;
}
</style>
